<div class="flashcard-widget">
  <div *ngIf="flashcard.dueDate && !hideDueDate" class="due-state-container" [class.is-due]="flashcard.dueDate < todaysDate">
    <i-tabler name="repeat" class="due-icon"></i-tabler>
    <span class="due-state">{{ flashcard.dueDate | dueState: todaysDate }}</span>
  </div>
  <p class="front-content" [innerHTML]="flashcard.question"></p>
  <p class="back-content" [innerHTML]="flashcard.answer"></p>
  <i-tabler name="dots-vertical" class="options-icon" (click)="handleActionsClick()"></i-tabler>
  <div class="desktop-options-container">
    <i-tabler *ngIf="!hideEdit" name="pencil" (click)="handleActionClicked('edit')"></i-tabler>
    <i-tabler name="trash" class="delete" (click)="handleActionClicked('delete')"></i-tabler>
  </div>
</div>